export default {
  GET_BV_PAGE_IMAGE_REQUEST: 'GET_BV_PAGE_IMAGE_REQUEST',
  GET_BV_PAGE_IMAGE_SUCCESS: 'GET_BV_PAGE_IMAGE_SUCCESS',
  GET_BV_PAGE_IMAGE_FAIL: 'GET_BV_PAGE_IMAGE_FAIL',
}
